import React from 'react';
import styled from 'styled-components';

const LayoutContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  position: relative;

  /* Improve mobile scrolling performance */
  -webkit-overflow-scrolling: touch;

  /* Better text rendering on mobile */
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;

  /* Prevent horizontal scroll on mobile */
  overflow-x: hidden;
`;

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return <LayoutContainer>{children}</LayoutContainer>;
};
